module.exports = __webpack_public_path__ + "img/travel-experience.79bbb366.jpg";